
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"23","viewBox":"0 0 28 23","width":"28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"height":"18","rx":"1.5","stroke":"#343440","width":"27","x":".5","y":"4"}}),_c('rect',{attrs:{"fill":"#343440","height":"11","rx":"1","width":"11","x":"3","y":"7.5"}}),_c('path',{attrs:{"d":"M11.752 18.5H5.247a.22.22 0 01-.156-.066.226.226 0 01-.065-.159 3.596 3.596 0 01.372-1.606 3.544 3.544 0 011.047-1.263.742.742 0 01.774-.076 2.777 2.777 0 002.552 0 .734.734 0 01.778.076c.44.328.799.756 1.046 1.25s.377 1.039.378 1.593a.252.252 0 01-.063.168.246.246 0 01-.158.083zM8.494 14.855c-.492 0-.972-.148-1.381-.425a2.513 2.513 0 01-.916-1.13 2.552 2.552 0 01.54-2.747 2.456 2.456 0 012.708-.546c.454.191.842.514 1.115.928a2.545 2.545 0 01-.309 3.182 2.484 2.484 0 01-1.757.738z","fill":"#fff"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M17 10.02a.52.52 0 01.52-.52h6.96a.52.52 0 110 1.041h-6.96a.52.52 0 01-.52-.52zm0 3.126a.52.52 0 01.52-.521h6.96a.52.52 0 110 1.042h-6.96a.52.52 0 01-.52-.521zm.52 2.479a.52.52 0 000 1.042h6.96a.52.52 0 000-1.042z","fill":"#343440","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M11.5 3a2.5 2.5 0 015 0v2.5h-5z","fill":"#fff","stroke":"#343440"}})])
          )
        }
      }
    